import { IIcon } from '@/types/generalTypes';

const MessageSquareIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_764_18220)'>
        <path
          d='M12.0002 6.00004H13.3335C13.6871 6.00004 14.0263 6.14052 14.2763 6.39056C14.5264 6.64061 14.6668 6.97975 14.6668 7.33337V14.6667L12.0002 12H8.00016C7.64654 12 7.3074 11.8596 7.05735 11.6095C6.80731 11.3595 6.66683 11.0203 6.66683 10.6667V10M9.3335 6.00004C9.3335 6.35366 9.19302 6.6928 8.94297 6.94285C8.69292 7.1929 8.35378 7.33337 8.00016 7.33337H4.00016L1.3335 10V2.66671C1.3335 1.93337 1.9335 1.33337 2.66683 1.33337H8.00016C8.35378 1.33337 8.69292 1.47385 8.94297 1.7239C9.19302 1.97395 9.3335 2.31309 9.3335 2.66671V6.00004Z'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_764_18220'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MessageSquareIcon;
